module.exports = __webpack_public_path__ + "static/media/6 Minutes  28 Feb2022.1183816a.pdf";